import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=e84cb574&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=e84cb574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84cb574",
  null
  
)

export default component.exports